class LazyLoadImage extends HTMLElement {
  constructor() {
    super();
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      {
        rootMargin: '100px',
      },
    );
  }

  connectedCallback() {
    this.observer.observe(this);
  }

  handleIntersection(entries) {
    if (entries[0].isIntersecting) {
      this.loadImage();
      this.observer.unobserve(this);
    }
  }

  loadImage() {
    this.setAttribute('src', this.getAttribute('data-src'));
    this.removeAttribute('data-src');
    this.classList.remove('invisible');
    if (this.parentElement.tagName === 'picture') {
      this.parentElement
        .querySelectorAll('source[data-srcset]')
        .forEach((source) => {
          // eslint-disable-next-line no-param-reassign
          source.srcset = source.getAttribute('data-srcset');
          source.removeAttribute('data-srcset');
          if (source.dataset.media) {
            // eslint-disable-next-line no-param-reassign
            source.media = source.dataset.media;
            source.removeAttribute('data-media');
          }
        });
    }
    this.outerHTML = this.outerHTML.replaceAll('lazy-img', 'img');
  }
}

if (!customElements.get('lazy-img')) {
  customElements.define('lazy-img', LazyLoadImage);
}
